import QuizIcon from '@material-ui/icons/FormatListNumbered';
import WinstonMemoryGameList from './components/WinstonMemoryGameList';
import { APP_TYPES, roles } from '../../../config/constants';

const options = {
  appTypes: [APP_TYPES.ALL],
  allowedRoles: [roles.ADMIN, roles.JTI_TEAM],
  label: 'Winston Memory Game',
  subMenuName: 'reports',
};

export default {
  list: WinstonMemoryGameList,
  icon: QuizIcon,
  name: 'admin/reports/winston-memory-game',
  options,
};
